// English strings. This file defines the translation keys (see i18next.d.ts);
// fi.ts must provide every one of them.
export const en = {
    app_name: "NHLCountries",

    // Header, menu, tabs
    tab_today: "Today",
    tab_upcoming: "Upcoming",
    tab_season: "Season",
    tab_league: "League",
    nav_label: "Sections",
    header_country: "Country",
    header_language: "Language",
    menu_open: "Menu",
    menu_updated: "Updated",
    menu_refreshFailing: "Refreshing failed, trying again",
    menu_theme: "Theme",
    theme_auto: "Auto",
    theme_light: "Light",
    theme_dark: "Dark",
    theme_teletext: "Teletext",
    menu_feedback: "Feedback",
    menu_showAddress: "show address",
    menu_hideAddress: "hide address",
    menu_version: "Version",
    menu_league: "League",
    menu_whatsNew: "What's new",
    whatsNew_title: "What's new",
    whatsNew_error: "Could not load the news.",
    whatsNew_empty: "Nothing here yet.",

    // Data states
    state_loading: "Loading data…",
    state_noData: "Could not load the data.",
    state_retry: "Try again",
    state_noPlayers: "No players",
    state_noGames: "No games",
    state_leagueUnavailable: "{{league}} data is not available right now.",
    state_toNhl: "Go to the NHL",
    error_view: "This view failed to load.",

    // Countries
    country_canada: "Canada",
    country_czechia: "Czechia",
    country_denmark: "Denmark",
    country_finland: "Finland",
    country_france: "France",
    country_germany: "Germany",
    country_latvia: "Latvia",
    country_norway: "Norway",
    country_russia: "Rogue state",
    country_slovakia: "Slovakia",
    country_sweden: "Sweden",
    country_switzerland: "Switzerland",
    country_usa: "USA",

    // Weekdays
    day_monday: "Mon",
    day_tuesday: "Tue",
    day_wednesday: "Wed",
    day_thursday: "Thu",
    day_friday: "Fri",
    day_saturday: "Sat",
    day_sunday: "Sun",

    // Tänään
    today_games: "Games",
    today_players: "Players",
    today_view: "View",
    filter_label: "Score display",
    filter_all: "All",
    filter_none: "None",
    hide_button: "Hidden teams",
    hide_enabled: "Hiding on",
    common_done: "Done",
    game_show: "show",
    game_showFor: "Show game {{teams}}",
    play_open: "Videos",
    play_recap: "Recap",
    play_condensed: "Condensed game",
    goal_video: "Goal video",
    points_short: "{{n}} pts",
    chart_perDay: "Points per day",
    chart_distribution: "Point distribution",
    chart_distributionHint: "Days with n points",
    col_player: "Player",
    col_game: "Game",
    col_points: "P",
    col_shots: "S",
    col_plusMinus: "+/-",
    col_toi: "TOI",
    col_savePct: "SV%",
    col_saves: "SV/SA",
    today_goalies: "Goalies",
    today_noPlayersYet: "No players have played yet",
    today_locked: "Player stats are hidden while scores are off.",
    today_showAnyway: "Show anyway",
    today_hiddenTeamsPlayers: "Players of hidden teams are not shown.",
    tracker_title: "Point tracker",
    tracker_notPlaying: "Not in lineup",
    tracker_upcoming: "Upcoming",
    tracker_start: "Starts",
    tracker_clock: "Game time",
    tracker_noPlayers: "No players on this game day",
    injury_dtd: "Day to day",
    injury_out: "Out for an unknown time",
    injury_ir: "Injured reserve",
    shotType_tipIn: "Tip-in",
    shotType_wristShot: "Wrist shot",
    shotType_slapShot: "Slap shot",
    shotType_deflected: "Deflected",
    shotType_snapShot: "Snap shot",
    shotType_backhand: "Backhand",
    shotType_wrapAround: "Wrap-around",
    shotType_betweenLegs: "Between the legs",
    shotType_poke: "Poke",
    shotType_bat: "Bat",
    goalType_pp: "PP",
    goalType_sh: "SH",
    goalType_en: "EN",
    gameEndingType_so: "SO",
    gameEndingType_ot: "OT",
    gameStatus_ppd: "PPD",
    gameStatus_tbd: "TBD",
    scores_game: "Game",
    scores_tied: "tied",
    scores_lead: "lead",
    scores_win: "win",
    scores_notStarted: "series tied 0-0",
    scores_startsSoon: "soon",
    scores_preSeasonGame: "Preseason game",

    // Column names in full (tooltips and screen readers)
    today_totalLabel: "Round points",
    today_yesterday: "Yesterday",
    scFull_name: "Name",
    scFull_team: "Team",
    scFull_games: "Games played",
    scFull_goals: "Goals",
    scFull_assists: "Assists",
    scFull_points: "Points",
    scFull_pointsPerGame: "Points per game",
    scFull_toi: "Time on ice per game",
    scFull_plusMinus: "Plus/minus",
    scFull_shotPct: "Shooting percentage",
    scFull_faceoffPct: "Faceoff percentage",
    scFull_primaryPosition: "Position",
    scFull_age: "Age",
    scFull_pim: "Penalty minutes",
    scFull_hits: "Hits",
    scFull_shots: "Shots",
    scFull_blocked: "Blocked shots",
    scFull_saves: "Saves",
    scFull_shotsAgainst: "Shots against",
    scFull_savePct: "Save percentage",
    scFull_gaa: "Goals against average",
    scFull_wins: "Wins",
    scFull_losses: "Losses",
    scFull_ot: "Overtime losses",
    scFull_sweaterNumber: "Sweater number",
    scFull_contract: "Contract ends",
    scFull_capHit: "Cap hit",

    // Tulevat
    upcoming_teams: "Teams",
    upcoming_showPlayers: "Show players",
    upcoming_teamsTitle: "Teams to show",
    upcoming_allTeams: "All teams",
    upcoming_none: "No upcoming games",

    // Kausi
    season_stats: "Stats",
    season_countryPoints: "Country points",
    season_news: "News",
    season_nationalTeam: "National team",
    season_view: "Season view",
    stats_skaters: "Skaters",
    stats_goalies: "Goalies",
    stats_playerType: "Player type",
    stats_scope: "Players",
    stats_all: "All",
    stats_average: "Average",
    stats_total: "Total",
    stats_noPlayers: "No players with games",
    stats_loadingAll: "Loading players of every country…",
    statColumn_name: "Name",
    statColumn_team: "T",
    statColumn_games: "GP",
    statColumn_goals: "G",
    statColumn_assists: "A",
    statColumn_points: "P",
    statColumn_pointsPerGame: "P/GP",
    statColumn_toi: "TOI",
    statColumn_plusMinus: "+/-",
    statColumn_shotPct: "S%",
    statColumn_faceoffPct: "FO%",
    statColumn_primaryPosition: "Pos",
    statColumn_age: "Age",
    statColumn_penaltyMinutes: "PIM",
    statColumn_sweaterNumber: "SN",
    statColumn_contract: "C",
    statColumn_capHit: "$",
    statColumn_saves: "SV",
    statColumn_shotsAgainst: "SA",
    statColumn_savePct: "SV%",
    statColumn_gaa: "GAA",
    statColumn_wins: "W",
    statColumn_losses: "L",
    statColumn_ot: "OTL",
    news_none: "No injury news",
    news_loading: "Loading news…",
    age_minutes: "{{n}} min",
    age_hours: "{{n}} h",
    age_days: "{{n}} d",
    nt_forwards: "Forwards",
    nt_defence: "Defence",
    nt_reserve: "Reserve",
    nt_notEnoughGames: "More games needed",
    nt_filter: "Team selection",
    nt_belowLine: "Below the playoff line",
    nt_capHit: "Team cap hit",
    nt_contractEnds: "Contract {{year}}",
    nt_empty: "No players to pick from",

    // Liiga
    league_standings: "Standings",
    league_playoffs: "Playoffs",
    league_tank: "Tank race",
    league_playoffsAndTank: "Playoffs and tank race",
    league_view: "League view",
    league_conference: "Conference",
    league_east: "East",
    league_west: "West",
    league_wc: "WC",
    league_pairsTitle: "First-round pairs",
    league_pairsNote: "by the current standings",
    league_belowLine: "Below the line",
    league_vsWc: "vs WC2",
    league_noTeams: "No standings yet",
    league_conferenceTank: "Tank race",
    standings_games: "GP",
    standings_points: "PTS",
    standings_wins: "W",
    standings_losses: "L",
    standings_ot: "OTL",
    standings_rw: "RW",
    standings_row: "ROW",
    standings_gr: "GR",
    standings_pointsPct: "P%",
    league_notePointsPct: "points percentage, the AHL's ranking",
    league_noteRw: "regulation wins",
    league_noteRow: "wins without shootouts",
    league_noteBlue: "blue = team has {{country}} players",
    league_noteDiv: "division position",
    league_noteWc: "wild card",
    league_noteGr: "games remaining",
    league_noteTank: "order: PTS, RW, ROW (lowest first)",
} as const;

export type TranslationKey = keyof typeof en;
